"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSymbol = exports.getDecimals = exports.explorerLink = exports.getInfuraProvider = exports.createProvider = void 0;
exports.createContract = createContract;
exports.getTokenMetadata = getTokenMetadata;
exports.simulateTransaction = simulateTransaction;
exports.toNormalizedBn = toNormalizedBn;
exports.checkAddress = checkAddress;
const constants_1 = require("../constants");
const ethers_1 = require("ethers");
function createContract({ provider, address, abi, }) {
    const goodAddress = checkAddress(address);
    if (!goodAddress)
        return;
    const contract = new ethers_1.Contract(address, abi, provider);
    if (!contract) {
        console.error('#createContract', 'contract does not exist on connected chain');
        return;
    }
    return contract;
}
const createProvider = (rpcUrl) => new ethers_1.JsonRpcProvider(rpcUrl);
exports.createProvider = createProvider;
const getInfuraProvider = (infura) => {
    let baseUrl = 'https://';
    switch (infura.chainId) {
        case 8453: {
            baseUrl = baseUrl + 'base-mainnet';
            break;
        }
        case 43114: {
            baseUrl = baseUrl + 'avalanche-mainnet';
            break;
        }
        case 137: {
            baseUrl = baseUrl + 'polygon-mainnet';
            break;
        }
        case 42161: {
            baseUrl = baseUrl + 'arbitrum-mainnet';
            break;
        }
        default: {
            baseUrl = baseUrl + 'mainnet';
            break;
        }
    }
    return new ethers_1.JsonRpcProvider(`${baseUrl}.infura.io/v3/${infura.apiKey}`);
};
exports.getInfuraProvider = getInfuraProvider;
const explorerLink = (hex, chain, type) => {
    if (!chain)
        return;
    return `${constants_1.NETWORKS[chain].explorer}/${type}/${hex}`;
};
exports.explorerLink = explorerLink;
const getDecimals = (provider, address) => __awaiter(void 0, void 0, void 0, function* () {
    if (!(address && provider))
        return;
    try {
        const contract = new ethers_1.Contract(address, [constants_1.MIN_ABIS.decimals], provider);
        return (yield contract.decimals());
    }
    catch (e) {
        console.error('#getDecimals:', e);
    }
});
exports.getDecimals = getDecimals;
const getSymbol = (provider, address) => __awaiter(void 0, void 0, void 0, function* () {
    if (!(address && provider))
        return;
    try {
        const contract = new ethers_1.Contract(address, [constants_1.MIN_ABIS.symbol], provider);
        return (yield contract.symbol());
    }
    catch (e) {
        console.error('#getSymbol:', e);
    }
});
exports.getSymbol = getSymbol;
function getTokenMetadata(provider, asset, meta) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!asset)
            return [];
        function buildAbi() {
            const abiArr = [];
            if (meta === null || meta === void 0 ? void 0 : meta.includes('name'))
                abiArr.push(constants_1.MIN_ABIS.name);
            if (meta === null || meta === void 0 ? void 0 : meta.includes('symbol'))
                abiArr.push(constants_1.MIN_ABIS.symbol);
            if (meta === null || meta === void 0 ? void 0 : meta.includes('decimals'))
                abiArr.push(constants_1.MIN_ABIS.decimals);
            if (meta === null || meta === void 0 ? void 0 : meta.includes('totalSupply'))
                abiArr.push(constants_1.MIN_ABIS.totalSupply);
            return abiArr;
        }
        try {
            const contract = new ethers_1.Contract(asset, buildAbi(), provider);
            const getterArr = [];
            if (meta === null || meta === void 0 ? void 0 : meta.includes('name'))
                getterArr.push(contract.name());
            if (meta === null || meta === void 0 ? void 0 : meta.includes('symbol'))
                getterArr.push(contract.symbol());
            if (meta === null || meta === void 0 ? void 0 : meta.includes('decimals'))
                getterArr.push(contract.decimals());
            if (meta === null || meta === void 0 ? void 0 : meta.includes('totalSupply'))
                getterArr.push(contract.totalSupply());
            return yield Promise.all(getterArr);
        }
        catch (e) {
            console.error('#getTokenMetadata:', e);
            return [];
        }
    });
}
function simulateTransaction(infura, abi, functionName, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = (0, exports.getInfuraProvider)(infura);
        try {
            const customInterface = new ethers_1.Interface(abi);
            const callData = customInterface.encodeFunctionData(functionName, options === null || options === void 0 ? void 0 : options.args);
            const response = yield provider.call({
                from: options === null || options === void 0 ? void 0 : options.from,
                to: options === null || options === void 0 ? void 0 : options.to,
                data: callData,
            });
            return customInterface.decodeFunctionResult(functionName, response);
        }
        catch (e) {
            console.error('#simulateTransaction:', e);
            if (String(e).includes('reverted with reason string "denied"'))
                return true;
            return false;
        }
    });
}
function toNormalizedBn(value, decimals = 18) {
    var _a, _b;
    if (!value)
        return { normalized: '0', raw: BigInt(0) };
    if (typeof value === 'string') {
        return {
            normalized: value !== null && value !== void 0 ? value : '0',
            raw: (0, ethers_1.parseUnits)(value, decimals),
        };
    }
    else if (typeof value === 'number') {
        return {
            normalized: (_a = String(value)) !== null && _a !== void 0 ? _a : '0',
            raw: (0, ethers_1.parseUnits)(String(value), decimals),
        };
    }
    else {
        return {
            normalized: (_b = (0, ethers_1.formatUnits)(value, decimals)) !== null && _b !== void 0 ? _b : '0',
            raw: value,
        };
    }
}
function checkAddress(address, logger, type = 'contract') {
    const _logger = logger !== null && logger !== void 0 ? logger : console;
    if (!address) {
        _logger.error(type, 'address is undefined');
        return false;
    }
    if (typeof address !== 'string') {
        _logger.error(type, 'address not of string type:', String(typeof address), String(address));
        return false;
    }
    if (!(0, ethers_1.isAddress)(address)) {
        _logger.error(type, 'address not checksummed:', String(address));
        return false;
    }
    return true;
}
//# sourceMappingURL=web3.js.map